import {makeObservable, observable} from 'mobx';

import {SelectionEntityModel} from "../../infrastructure/models/selection-entity.model";
import {DomUtils} from "../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../bootstrap/models/site-config";
import {DeviceStore} from "../app/device.store";
import {DatetimeUtils} from "../../infrastructure/utils/datetime-utils";
import {LOCAL_STORAGE_KEYS} from "../consts";
import {BaseManager} from "../../infrastructure/managers/base-manager";
import {LocalStorageUtils} from "../../infrastructure/utils/local-storage.utils";
import {singleton} from "../../infrastructure/decorators/singleton";
import {UserSelectionModel} from "../models/user-selection.model";

@singleton
export class BlackListManager extends BaseManager {
  @observable blackListSelections: Array<UserSelectionModel>;

  static injectables = [...BaseManager.injectables, LocalStorageUtils, DatetimeUtils];
  datetimeUtils: DatetimeUtils;

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    localStorageUtils: LocalStorageUtils,
    datetimeUtils: DatetimeUtils
  ) {
    super(domUtils, logger, siteConfig, deviceStore);

    makeObservable(this);

    this.datetimeUtils = datetimeUtils;
    this.localStorageUtils = localStorageUtils;

    this.blackListSelections = this.fetch();

    this.removeExpired();
  }

  fetch(): Promise<Array<SelectionEntityModel>> {
    const selections: Array<Object> = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.blackListUserSelections) || [];
    const selectionsVM: Array<SelectionEntityModel> = selections.map((selection: SelectionEntityModel) => {
      return new SelectionEntityModel(selection.id, selection.type, selection.date, selection.source)
    });

    return selectionsVM;
  }

  async add(userSelection: SelectionEntityModel) {
    this.blackListSelections.push(userSelection);

    return this.localStorageUtils.set(LOCAL_STORAGE_KEYS.blackListUserSelections, this.blackListSelections);
  }

  async remove(userSelection: SelectionEntityModel) {
    this.blackListSelections = this.blackListSelections.filter((selection: SelectionEntityModel) => !userSelection.equals(selection));

    return this.localStorageUtils.set(LOCAL_STORAGE_KEYS.blackListUserSelections, this.blackListSelections);
  }

  async removeExpired() {
    this.blackListSelections = this.blackListSelections.filter((selection: SelectionEntityModel) => !this.isSelectionExpired(selection))

    return this.localStorageUtils.set(LOCAL_STORAGE_KEYS.blackListUserSelections, this.blackListSelections);
  }

  isSelectionExpired(selection: SelectionEntityModel) {
    let isExpired: Boolean = false;

    if (selection.date) {
      const date = this.datetimeUtils.fromISO(selection.date);
      const countDaysFromToday = this.datetimeUtils.diffDaysByDate(date);
      isExpired = countDaysFromToday < -14;
    }

    return isExpired;
  }
}
